import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class TelecallerMasterService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private baseUrl = 'api/telecallerMaster';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    getTelecallerList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getTelecallerList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    addUpdateTelecaller(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/addUpdateTelecaller`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }

    getFollowupTeamList(): Promise<any> {
        let options = new RequestOptions({ headers: this.headers });
        return this.http.get(`${this.baseUrl}/getFollowupTeamList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getEmployeeList(search: string): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('search', search);
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getEmployeeList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getSlotList(): Promise<any> {
        let options = new RequestOptions({ headers: this.headers });
        return this.http.get(`${this.baseUrl}/getSlotList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/telecallerMaster.service.ts